// FunctionContext.js
import React, { createContext, useContext, useState } from "react";

const FunctionContext = createContext();

export const FunctionProvider = ({ children }) => {
  const [purchasedPackage, setPurchasedPackage] = useState(null);

  const updatePurchasedPackage = (packageData) => {
    setPurchasedPackage(packageData);
  };

  return (
    <FunctionContext.Provider
      value={{ purchasedPackage, updatePurchasedPackage }}
    >
      {children}
    </FunctionContext.Provider>
  );
};

export const useFunctionContext = () => useContext(FunctionContext);
